module.exports = __webpack_public_path__ + "img/etx.a1145ff6.png";